/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * Helper class find objects in the scene using the graph path.
 * A path is smth. like "Parent.child"
 */
export class SceneGraphPath {
    static getObjectByPath(scene, path) {
        let currentObj = scene;
        SceneGraphPath._split(path).forEach((name) => {
            if (currentObj) {
                currentObj = currentObj.getObjectByName(name);
            }
        });
        return currentObj;
    }
    static findObjectByName(scene, name) {
        return SceneGraphPath._findRecursiv(scene.children, name);
    }
    static _findRecursiv(objs, name) {
        let match;
        for (let i = 0; !match && i < objs.length; i++) {
            if (objs[i].name === name) {
                match = objs[i];
            }
            else {
                match = SceneGraphPath._findRecursiv(objs[i].children, name);
            }
        }
        return match;
    }
    static _split(path) {
        return path.split(/[.]/); // TODO : do not match escaped dots
    }
}
//# sourceMappingURL=SceneGraphPath.js.map